import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

const ctaActions = ['enroll', 'enroll_in_offer', 'launch_link', 'enrollment_full'] as const
const enrolledCtaAction = ['launch_link'] as const

export const CardBenefitSchema = z.object(
  {
    header: z.string(),
    preview_img: z.string(),
    hero_img: z.string(),
    thumbnail_img: z.string(),
    title: z.string(),
    summary: z.string(),
    enrollment_full_summary: z.string().optional(),
    how_to_redeem: z.array(z.string()),
    terms: z.array(z.string()),
    enrolled_cta_action: z
      .enum(enrolledCtaAction, {
        message: `enrolled_cta_action must be one of ${enrolledCtaAction.join(', ')}`,
      })
      .optional(),
    enrolled_cta_link: z.string().optional(),
    enrolled_cta_action_text: z.string().optional(),
    cta_action: z
      .enum(ctaActions, { message: `cta_action must be one of ${ctaActions.join(', ')}` })
      .optional(),
    cta_link: z.string().optional(),
    cta_text: z.string().optional(),
    navigate_to: z
      .object({
        pathname: z.string(),
      })
      .optional(),
    theme: z.object({
      badgeBackgroundColor: z.string().optional(),
      backgroundColor: z.string().optional(),
      color: z.string().optional(),
    }),
    should_hide_from_list: z.boolean().optional(),
  },
  { message: 'Benefits object is not valid' },
)

export type CardBenefit = z.infer<typeof CardBenefitSchema>

export type CardBenefitsStore = {
  benefits_v1: Record<string, CardBenefit>
  learn_more: string[]
  disclosures: { is_enabled: boolean; markdown_text: string }[][]
}

export function useCardBenefitsParameterStore() {
  return useMesaParameterStore('card_benefits')
}
